import { render, staticRenderFns } from "./ClearRefinements.vue?vue&type=template&id=57cd051f&"
import script from "./ClearRefinements.vue?vue&type=script&lang=js&"
export * from "./ClearRefinements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports